import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SwitchComponent } from '@webapp/ui';

@Component({
  selector: 'app-profile-security',
  standalone: true,
  imports: [SwitchComponent],
  templateUrl: './profile-security.component.html',
  styleUrl: './profile-security.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSecurityComponent {}
